
export default [
    'AOG',
    'HUM',
    'VIP',
    'DIP',
    'DIC',
    'NWP',
    'VUN',
    'COU',
    'ACE',
]